/* AB ab_flex_offer — sunsets 2026-10-31, delete src/pages/AB_FlexOfferSuivi/ */

import { Navigate } from 'react-router-dom';

import { AB_FlexOfferSuiviPage } from './AB_FlexOfferSuiviPage';
import { useAB_FlexOfferEligible } from './AB_useFlexOfferEligible';

export const AB_FlexOfferSuiviRoute = (): JSX.Element => {
    const isEligible = useAB_FlexOfferEligible();
    if (!isEligible) {
        return <Navigate to="/homepage" replace />;
    }
    return <AB_FlexOfferSuiviPage />;
};
